/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

export interface VirtualRoom {
  /** Unique identifier */
  id: string;
  /**
   * User who created the entity
   * @nullable
   */
  createdById?: string | null;
  /**
   * User who last updated the entity
   * @nullable
   */
  updatedById?: string | null;
  /** Creation timestamp */
  createdAt?: string;
  /** Update timestamp */
  updatedAt?: string;
  integrationId: string;
  /** @nullable */
  spaceId?: string | null;
  externalId: string;
  /** @nullable */
  displayName?: string | null;
  /**
   * Room mailbox address, used for all calendar Graph calls
   * @nullable
   */
  email?: string | null;
  /** @nullable */
  externalSubscriptionId?: string | null;
  /** @nullable */
  expirationDateTime?: string | null;
}
